module.exports = __webpack_public_path__ + "static/media/checkCard.37e842e1.svg";